import React from "react";
import { Link } from "react-scroll";

function Footer() {
  return (
    <footer className="footer--container">
      <div className="footer--link--container">
        <div className="footer--items">
          <ul>
            <li>
              <Link
                activeClass="navbar--active-content"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="heroSection"
                className="text-md"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                activeClass="navbar--active-content"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="AboutMe"
                className="text-md"
              >
                About Me
              </Link>
            </li>
            <li>
              <Link
                activeClass="navbar--active-content"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="mySkills"
                className="text-md" >
                Expertise
              </Link>
            </li>
            <li>
              <Link
                activeClass="navbar--active-content"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="MyPortfolio"
                className="text-md" >
                Portfolio
              </Link>
            </li>
            <li>
              <Link
                activeClass="navbar--active-content"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="Contact"
                className="text-md">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer--social--icon">
          <ul>
            <li>
              <a
                href="https://github.com/DesaiHetvi98?tab=repositories"
                className="navbar--content"
                target="_blank"
                rel="noopener noreferrer">
                  <img src="./img/github.png" alt="Github icon" className="github-logo"/>                  
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/hetvi-desai-276a14132/"
                className="navbar--content"
                target="_blank"
                rel="noopener noreferrer">
                    <img src="./img/linkedin.png" alt="Linkedin icon" className="github-logo"/>               
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr className="divider" />
      <div className="footer--content--container">
        <p className="footer--content">Made with &#128150; by Hetvi</p>
      </div>
    </footer>
  );
}

export default Footer;